export default "__VITE_ASSET__B1mISxyN__"